module.exports = __webpack_public_path__ + "img/97.45dc80da.webp";